import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function PaymentFailedPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('order') || '';

  useEffect(() => {
    // Aynı iframe çıkışı mantığı: Paytr bu sayfayı iframe içinde açar,
    // biz üst pencereyi aynı adrese yönlendiriyoruz ki kullanıcı net bir
    // hata ekranı görsün ve tekrar deneyebilsin.
    if (window.self !== window.top && window.top) {
      window.top.location.href = window.location.href;
    }
  }, []);

  if (window.self !== window.top) {
    return <div className="min-h-[200px]" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-3xl shadow-xl p-12 text-center max-w-md mx-4">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">❌</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Ödeme Tamamlanamadı</h2>
        <p className="text-gray-500 mb-4">
          Ödemeniz sırasında bir sorun oluştu. Kart bilgilerinizi kontrol edip tekrar deneyebilir
          veya farklı bir kartla ödeme yapabilirsiniz.
        </p>
        {orderNumber && (
          <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl px-6 py-4 mb-6">
            <p className="text-xs text-gray-500 mb-1">Sipariş Numarası</p>
            <p className="text-xl font-black text-gray-700 tracking-wider">{orderNumber}</p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate('/odeme')}
            className="px-6 py-3 bg-[#E31E24] text-white font-bold rounded-xl hover:bg-[#c41a1f] transition-colors"
          >
            Tekrar Dene
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-xl hover:bg-gray-200 transition-colors"
          >
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    </div>
  );
}
